module.exports = __webpack_public_path__ + "fonts/webfont.0ea14741.eot";